import { RepaymentTable } from './RepaymentTable'

export default RepaymentTable
